<template>
  <div class="comprehensive-form-container">
    <el-row :gutter="20">
      <el-col
        :lg="{ span: 12, offset: 6 }"
        :md="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :xl="{ span: 12, offset: 6 }"
        :xs="24"
      >
        <el-form
          ref="form"
          class="demo-form"
          :label-position="labelPosition"
          label-width="100px"
          :model="form"
          :rules="rules"
        >
          <el-form-item label="推送密钥">
            <el-input class="fix-width" v-model.trim="form.key" placeholder="请输入推送密钥" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">
              保存
            </el-button>
            <!-- <el-button @click="resetForm('form')">重置</el-button> -->
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getBangqi, setupBangqi } from '@/api/super'
  export default {
    name: 'SettingsBangqi',
    data() {
      return {
        labelPosition: 'right',
        form: {
          key: '',
        },
        rules: {},
      }
    },
    async mounted() {
      this.getData()
    },
    methods: {
      async getData() {
        const config = await getBangqi({})
        this.form.key = config && config.basic && config.basic.key || ''
      },
      submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            const config = await setupBangqi({
              config: { key: this.form.key }
            })
            this.$message.success('保存邦奇配置成功')
          } else {
            this.$message.success('保存邦奇配置失败')
            return false
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      },
    },
  }
</script>

<style lang="scss" scoped>
.fix-width {
  width: 500px;
}
</style>
